<ion-header [hidden]="scanCamera">
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>
            Objecten
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content [hidden]="scanCamera" [class]="(!objlist.length && currObjNr) ? 'showMap' : ''">
    <ion-card>
        <ion-item>
            <input placeholder="Object nummer" class="inputField" onclick="this.select()"
                (input)='onChange($any($event.target).value)' [(ngModel)]="inpObj">
            <ion-button (click)="doScan()" [hidden]="global.optHideScanBtn">
                <ion-icon name="barcode"></ion-icon>
            </ion-button>
        </ion-item>
        <ion-item *ngIf="objlist.length">
            <ion-list style="max-height: 300px; overflow-y: scroll; width: 100%;">
                <ion-item *ngFor="let obj of objlist">
                    <ion-label (click)="click_obj(obj.nr)">{{ obj.des }}</ion-label>
                </ion-item>
            </ion-list>
        </ion-item>
    </ion-card>
    <ion-card [class]="(!objlist.length && currObjNr && currObj) ? 'showMap' : ''"
        [hidden]="!(!objlist.length && currObjNr && currObj)">
        <div class='gmap'>
            <capacitor-google-map #googlemap></capacitor-google-map>
        </div>
    </ion-card>
    <ion-card *ngIf="!objlist.length && currObjNr">
        <ion-item *ngIf="!objlist.length">
            <table class='taglist'>
                <tr *ngFor="let row of currObj">
                    <td>
                        <a *ngIf="row.key==='Adres' && row.val>''" target="_system" [href]=mapsUrl(row.val)>
                            <ion-button size="small"><ion-icon name="location"></ion-icon></ion-button>
                        </a>
                        <ion-button *ngIf="row.key==='Klant' && row.val>''" size="small"
                            (click)="router.navigate(['/bedrijf/' + row.val])"
                        >
                            <ion-icon name="attach"></ion-icon>
                        </ion-button>
                    </td>
                    <td><span class="tag">{{row.key}}</span></td>
                    <td style="white-space: pre;">{{row.val}}</td>
                </tr>
            </table>
        </ion-item>
        <ng-container *ngIf="!objlist.length && currObjNr">
            <ion-item *ngIf="!dlgNwOrder && ordNr">
                Aangemaakte order: <b>{{ordNr}}</b>
            </ion-item>
            <ion-item *ngIf="!dlgNwOrder">
                <ion-button (click)="doNwOrder()">
                    Nieuwe order
                </ion-button>
                <ion-button id=chObjPos>
                    Object positie
                </ion-button>
                <ion-alert trigger="chObjPos" header="Object positie bijwerken naar uw huidige locatie?"
                    [buttons]="confirmButtons" (didDismiss)="doChObjPos($event)"></ion-alert>
            </ion-item>
        </ng-container>
    </ion-card>
    <ion-card *ngIf="objlist && orders && !objlist.length && currObjNr && !dlgNwOrder && orders.length">
        <ion-item>
            <table class='afstand'>
                <tr *ngFor="let row of orders">
                    <td class='link' (click)="click_proj(row.LiproNr)">{{row.LiproNr}}</td>
                    <td>:</td>
                    <td>{{row.Omschrijving}}</td>
                </tr>
            </table>
        </ion-item>
    </ion-card>
    <ion-card *ngIf="dlgNwOrder">
        <h2>Order aanmaken voor dit object</h2>
        <ion-item>
            <input type='text' placeholder="Order omschrijving" class="inputField" style="width: 100%;"
                [(ngModel)]="ordOmsch">
        </ion-item>
        <ion-list radio-group>
            <ion-radio-group [(ngModel)]="ordType">
                <ion-list-header>Type order</ion-list-header>
                <ion-item>
                    <ion-label>Onderhoud</ion-label>
                    <ion-radio value="O"></ion-radio>
                </ion-item>
                <ion-item>
                    <ion-label>Reparatie</ion-label>
                    <ion-radio value="R"></ion-radio>
                </ion-item>
                <ion-item>
                    <ion-label>Storing</ion-label>
                    <ion-radio value="S"></ion-radio>
                </ion-item>
                <ion-item>
                    <ion-label>Overig</ion-label>
                    <ion-radio value="-"></ion-radio>
                </ion-item>
            </ion-radio-group>
        </ion-list>
        <ion-item>
            <ion-button (click)="doNwOrderIns()">
                Aanmaken
            </ion-button>
        </ion-item>
    </ion-card>
</ion-content>